import { useState, useContext } from 'react'
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import MobileNavigation from '../../common/mobileNavigation';

export default function SavingsMobileNavigation({ clickAnalytics, navItems }: any) {
    const dispatch: any = useContext(DataDispatchContext)
    const data: any = useContext(DataContext)
    const [selected, setSelected] = useState(data?.savingsSelected);

    const handleMenuClick = (event: any) => {
        const id = `${event.currentTarget.id}`.replace('Mobile','')
        setSelected(id)
        dispatch({
          type: 'setSavingsSelected',
          selected: id
        })
        clickAnalytics(id)
      }

      const navItemList = (navItems || []).map((item: any)=>(
        {
          ...item,
          action: handleMenuClick
        }
      ))

    const itemSelected: any = navItemList.find((item: any)=>item.id===selected)


    return (
      <MobileNavigation 
        navItemList={navItemList}
        title={"Savings"}
        itemSelected={itemSelected}
        defaultSelected={data?.savingsSelected}
        handleMenuClick={handleMenuClick}
    />
    )
}